import { createSlice } from "@reduxjs/toolkit"

/**
 * De duiklocatielijst uit `GET /eggspedition/dive-sites`.
 *
 * In redux en niet in componentstate omdat het er ruim 8000 zijn (~2 MB) en de lijst zelden
 * verandert: één keer per sessie ophalen is genoeg. Zonder dit zou elk bezoek aan het
 * uploadformulier hem opnieuw binnenhalen.
 *
 * `loaded` staat los van `items.length`, zodat een (theoretisch) lege lijst niet elke render een
 * nieuwe poging uitlokt.
 */
export const diveSitesSlice = createSlice({
  name: "diveSites",
  initialState: { items: [], loaded: false },
  reducers: {
    set: (state, action) => ({ items: action.payload || [], loaded: true })
  }
})

export const { set: setDiveSites } = diveSitesSlice.actions

export default diveSitesSlice.reducer
